// Invoices
export const INVOICES = '/invoices';
export const INVOICE_DETAILS = invoiceNumber => `/invoices/${invoiceNumber}`;